export default __webpack_public_path__ + "static/media/7.29f4e6ad.svg";